import { ID } from '../../../constants';

const shouldSkipSingleQuery = (loading, getAction, queryProps) =>
  loading || !getAction || queryProps === ID;

export default shouldSkipSingleQuery;
